import { SEAT_LAYOUT_URL, RATING_REVIEW_URL, RED_DEAL_URL, CANCELLATION_POLICY_URL, BUS_DETAIL_URL, SEAT_DEALS, BUS_INFO_GET_BUS_DETAILS } from './../../config/apiPoints';

export const prepareSeatLayoutAPIRequest = () => {
  const url = `${__ENV_CONFIG__.__CB_HOST__}${SEAT_LAYOUT_URL}`;
  return url;
};

export const prepapreRatingReviewAPIRequest = (routeId: string) => {
  const routeIdArr = routeId.split("@");
  const id = routeIdArr[routeIdArr.length - 1];
  const url = `${__ENV_CONFIG__.__DEPOT__}${RATING_REVIEW_URL}${id}`;
  return url;
}

export const prepareRedDealAPIRequest = (query: string) => {
  const url = `${__ENV_CONFIG__.__GOIBIBO__}${RED_DEAL_URL}${query}`
  return url;
}

export const prepareRedDealAPIRequestNew = () => {
  const url = `${__ENV_CONFIG__.__CB_HOST__}${SEAT_DEALS}`
  return url;
}

export const prepareCancellationPolicyURL = (bid: string, src_vid: string, dest_vid: string,tripKey:string) => {
  let url = `${__ENV_CONFIG__.__GOIBIBO__}${CANCELLATION_POLICY_URL}${bid}&src_vid=${src_vid}&dest_vid=${dest_vid}&tripKey=${tripKey}`;  
  return url;
}

export const prepareBusDeatilRequest = () => {
  const url = `${__ENV_CONFIG__.__CB_HOST__}${BUS_INFO_GET_BUS_DETAILS}`
  return url;
}